import React, {useState} from "react";
import {Upload, Input, Button, message} from "antd";
import "./Feedback.css"
import html2canvas from "html2canvas";
import {base64ToFormData, getBase64} from "../../util/fileUtil";
import {problemCommit, uploadFile} from "../../ApiService";
import { nanoid } from 'nanoid'
import {RcFile} from "antd/es/upload/interface";
import {encryptData} from "../../util/pako";
import {safeTruncate} from "../../util/strUtil";

function getStyleLang(firstLang) {
  switch(firstLang) {
    case 'python3':
      return 'python';
    case 'rust':
      return 'bash';
    case 'mysql':
      return 'sql';
    case 'golang':
      return 'go';
    case 'systemverilog':
      return 'c';
    default:
      return firstLang;
  }
}

export default ({closeMe, token, lang, code, preview}) => {
  const [feedbackText, setFeedbackText] = useState ('');
  const [imageList, setImageList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  const imagePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || (file.preview));
    setPreviewOpen(true);
  };

  const submitFeedback = async() => {
    if (!feedbackText) {
      message.warning('请先输入反馈内容');
      return;
    }

    const imgUrlArr = [];
    for await (const item of imageList) {
      const formData = base64ToFormData(item.thumbUrl || '');
      const imgUrl = await uploadFile(formData);
      imgUrlArr.push(imgUrl);
    }

    // 全屏截图并上传
    let shotImgUrl = '';
    try {
      const canvas = await html2canvas(document.getElementById("acm"));
      const base64 = canvas.toDataURL("image/png");
      const shotFormData = base64ToFormData(base64, "feedback-screenshot.png");
      const shotImgData = await uploadFile(shotFormData);
      shotImgUrl = shotImgData.url
    } catch (err) {
      console.error("全屏截图失败:", err);
    }

    // console.log(imgUrlArr, 'imgUrlArr');
    let imgStr = '';
    imgUrlArr.forEach(data => {
      const str = `<img src='${data.url}' />`
      imgStr += str;
    })
    let firstLang = lang?lang[0]:'未知'
    const text = feedbackText + '<br>' + imgStr;
    let fullContent = "<h3>用户反馈</h3>";
    fullContent += `<p>${feedbackText}</p>`;
    if (imgStr) {
      fullContent += `<p>${imgStr}</p>`;
    }
    fullContent += '<h3>页面地址</h3>'
    fullContent += `<p>${window.location.href}</p>`;
    fullContent += '<h3>语言</h3>'
    fullContent += `<p>${firstLang}</p>`
    fullContent += '<h3>代码</h3>'
    let styleLang = getStyleLang(firstLang)
    fullContent += `<pre><code class="language-${styleLang}">${code}</code></pre>`;
    fullContent += '<h3>输出</h3>'
    fullContent += `<pre><code class="language-bash">${preview}</code></pre>`;
    if (shotImgUrl){
      fullContent += '<h3>全屏截图</h3>'
      fullContent += `<img alt="全屏截图" src='${shotImgUrl}' />`
    }
    const obj = {
      chapter: "summary",
      code: process.env.REACT_APP_FEEDBACK_BLOG_CODE,
      content: fullContent,
      cooperateUrl: process.env.REACT_APP_FEEDBACK_BLOG_LINK,
      labCode: process.env.REACT_APP_FEEDBACK_LAB_CODE,
      title: safeTruncate(feedbackText,10),
      labels: ["runner"],
    }
    // console.log(obj, 'obj')

    const params = {
      requestId: nanoid(),
      encodeData: encryptData(obj),
    }

    problemCommit(params, token).then(() => {
      message.success('提交成功，后续可以在我的消息中看到回复');
      setFeedbackText('');
      setImageList([]);
      closeMe && closeMe();
    })
  }

  return (
  <div className="feedback">
    <div className="feedback-title">亲爱的用户朋友，感谢您的使用！请输入您的宝贵意见：</div>
    <div className="feedback-input">
      <Input.TextArea
        value={feedbackText}
        onChange={(e) => setFeedbackText(e.target.value)} rows={5}
        placeholder='请输入你想反馈的问题内容'
      />
    </div>
    <div className="feedback-upload">
      <Upload
        customRequest={async (options) => {
          const {file, onSuccess, onError} = options;
          try {
            setTimeout(() => {
              onSuccess("ok", file);
            }, 0);
          } catch (error) {
            onError(new Error('Upload failed'));
          }
        }}
        maxCount={5}
        listType="picture-card"
        accept=".jpg, .png, .svg, .jpeg, .gif"
        fileList={imageList}
        onChange={({fileList}) => {
          setImageList(fileList);
        }}
        onPreview={imagePreview}
        beforeUpload={(file) => {
          const size = file.size / 1024 / 1024;
          const isLt5M = size < 5;
          if (!isLt5M) {
            message.error(`${file.name} 文件大小超过5MB，无法上传`);
            return Upload.LIST_IGNORE; // 阻止上传
          }
          return true; // 允许上传
        }}
      >
        {imageList.length >= 5 ? null : <button style={{border: 0, background: 'none'}} type="button">
          <spin>+</spin>
          <div style={{marginTop: 8}}>上传图片</div>
        </button>}
      </Upload>
    </div>
    <div className="feedback-submit">
      <Button type='primary' onClick={submitFeedback}>提交</Button>
    </div>
  </div>
  )
}